var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxiAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5C16.09 13.5 14.37 12.74 13.11 11.5H4.81L5.85 8.5H11.29C11.1 7.87 11 7.2 11 6.5C11 5.8 11.1 5.13 11.29 4.5H9C8.45 4.5 8 4.95 8 5.5V6.5H5.5C4.84 6.5 4.29 6.92 4.08 7.51L2 13.5V21C2 21.82 2.67 22.5 3.5 22.5C4.33 22.5 5 21.82 5 21V20.5H17V21C17 21.82 17.67 22.5 18.5 22.5C19.33 22.5 20 21.82 20 21V13.5L19.91 13.23C19.3 13.4 18.66 13.5 18 13.5ZM6.5 17.5C5.67 17.5 5 16.83 5 16C5 15.17 5.67 14.5 6.5 14.5C7.33 14.5 8 15.17 8 16C8 16.83 7.33 17.5 6.5 17.5ZM15.5 17.5C14.67 17.5 14 16.83 14 16C14 15.17 14.67 14.5 15.5 14.5C16.33 14.5 17 15.17 17 16C17 16.83 16.33 17.5 15.5 17.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5C15.24 1.5 13 3.74 13 6.5C13 9.26 15.24 11.5 18 11.5C20.76 11.5 23 9.26 23 6.5C23 3.74 20.76 1.5 18 1.5ZM18 9.5C17.72 9.5 17.5 9.28 17.5 9C17.5 8.72 17.72 8.5 18 8.5C18.28 8.5 18.5 8.72 18.5 9C18.5 9.28 18.28 9.5 18 9.5ZM18.5 7C18.5 7.28 18.28 7.5 18 7.5C17.72 7.5 17.5 7.28 17.5 7V4C17.5 3.72 17.72 3.5 18 3.5C18.28 3.5 18.5 3.72 18.5 4V7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiAlert);
export default __webpack_public_path__ + "static/media/taxi-alert.0a23809759b7656e62c6906dda192d87.svg";
export { ForwardRef as ReactComponent };